var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11905 11.5714C5.02605 11.5714 4.91444 11.5513 4.82143 11.5112C4.72843 11.471 4.63542 11.4108 4.56102 11.3104L0.598963 7.03396C0.431552 6.87335 0.357147 6.67257 0.357147 6.43165C0.357147 6.19072 0.431552 5.98995 0.598963 5.82933C0.747772 5.64864 0.933784 5.56833 1.157 5.56833C1.36161 5.56833 1.54762 5.64864 1.71503 5.82933L5.11905 9.50346L13.285 0.689562C13.4524 0.508867 13.6384 0.428558 13.8616 0.428558C14.0662 0.428558 14.2522 0.508867 14.401 0.689562C14.5685 0.85018 14.6429 1.05095 14.6429 1.29188C14.6429 1.53281 14.5685 1.73358 14.4196 1.8942L5.67709 11.3104C5.60268 11.4108 5.50968 11.471 5.41667 11.5112C5.32367 11.5513 5.21206 11.5714 5.11905 11.5714Z",
    fill: "#091B3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfCheck);
export default __webpack_public_path__ + "static/media/ff-check.2b7b09302c79e76b2d5d3e54f63244b5.svg";
export { ForwardRef as ReactComponent };